import React from 'react';
import './LoadingSkeleton.scss';
import { Shimmer } from '@trp-ii-ii-component-library/ii-components';

const CARD_WIDTH = 284;
const MAIN_WIDTH = 775;
const ACCOUNTS_GRID_WIDTH = 1320;

const CardShell = ({ children, className }) => {
  return (
    <div className={`card-shell ${className}`}>
      <Shimmer x={className.includes('dashboard-main') ? 800 : 332} y={50} />
      {children}
    </div>
  );
};

export const AccountsLoadingCard = () => {
  return (
    <CardShell className="dashboard-main accounts-table">
      <div className="shimmer-container">
        <Shimmer x={MAIN_WIDTH} y={60} />
        <Shimmer x={MAIN_WIDTH} y={90} />
        <Shimmer x={MAIN_WIDTH} y={50} />
        <Shimmer x={MAIN_WIDTH} y={50} />
        <Shimmer x={MAIN_WIDTH} y={50} />
        <Shimmer x={MAIN_WIDTH} y={50} />
        <Shimmer x={MAIN_WIDTH} y={50} />
        <Shimmer x={MAIN_WIDTH} y={90} />
        <Shimmer x={MAIN_WIDTH} y={50} />
      </div>
    </CardShell>
  );
};

export const ExternalAccountsLoadingCard = () => {
  return (
    <CardShell className="dashboard-main external-accounts-card">
      <div className="shimmer-container">
        <Shimmer x={750} y={40} />
        <Shimmer x={750} y={40} />
        <Shimmer x={750} y={40} />
      </div>
    </CardShell>
  );
};

export const PRRCard = () => {
  return (
    <CardShell className="dashboard-card prr-card">
      <div className="shimmer-container">
        <Shimmer x={CARD_WIDTH} y={30} />
        <Shimmer x={CARD_WIDTH} y={45} />
        <Shimmer x={CARD_WIDTH} y={30} />
      </div>
    </CardShell>
  );
};

export const AssetAllocationCard = () => {
  return (
    <CardShell className="dashboard-card asset-allocation">
      <div className="shimmer-container">
        <Shimmer x={147} y={147} shape="circle" />
        <Shimmer x={CARD_WIDTH} y={40} />
        <Shimmer x={CARD_WIDTH} y={40} />
        <Shimmer x={CARD_WIDTH} y={40} />
        <Shimmer x={CARD_WIDTH} y={40} />
        <Shimmer x={CARD_WIDTH} y={40} />
        <div className="shimmer-footer">
          <Shimmer x={130} y={25} />
        </div>
      </div>
    </CardShell>
  );
};

export const SummitCard = () => {
  return (
    <CardShell className="dashboard-card summit-card">
      <div className="shimmer-container">
        <Shimmer x={CARD_WIDTH} y={25} />
        <Shimmer x={CARD_WIDTH} y={50} />
        <Shimmer x={CARD_WIDTH} y={35} />
        <Shimmer x={CARD_WIDTH} y={25} />
        <Shimmer x={CARD_WIDTH} y={50} />
        <Shimmer x={CARD_WIDTH} y={35} />
        <Shimmer x={CARD_WIDTH} y={25} />
        <Shimmer x={CARD_WIDTH} y={50} />
        <Shimmer x={CARD_WIDTH} y={35} />
      </div>
    </CardShell>
  );
};

export const AccountsPageHeaderSkeleton = () => {
  return (
        <div className="accounts-page shimmer-container">
          <Shimmer x={CARD_WIDTH} y={55}/>
          <Shimmer x={CARD_WIDTH} y={55}/>
        </div>
  )
};

export const AccountsPageSelectorsSkeleton = () => {
    return (
        <div className="accounts-page shimmer-container">
            <Shimmer x={400} y={45}/>
            <Shimmer x={400} y={45}/>
            <Shimmer x={400} y={45}/>
        </div>
    )
};

export const AccountsGridSkeleton = () => {
    return (
        <div className="accounts-grid-shell">
            <Shimmer x={ACCOUNTS_GRID_WIDTH} y={45}/>
            <Shimmer x={ACCOUNTS_GRID_WIDTH} y={45}/>
            <Shimmer x={ACCOUNTS_GRID_WIDTH} y={45}/>
            <Shimmer x={1290} y={80}/>
            <Shimmer x={1290} y={80}/>
            <Shimmer x={1290} y={80}/>
            <Shimmer x={ACCOUNTS_GRID_WIDTH} y={45}/>
            <Shimmer x={1290} y={120}/>
            <Shimmer x={1290} y={100}/>
        </div>
    )
};

export const WorkplaceRetirementGridSkeleton = () => {
    return (
        <div className="workplace-retirement-grid-shell">
            <Shimmer x={ACCOUNTS_GRID_WIDTH} y={45}/>
            <Shimmer x={1290} y={60}/>
        </div>
    )
};

export const FactSetSkeleton = () => {
    return (
        <div className="fact-set-shell">
            <Shimmer x={ACCOUNTS_GRID_WIDTH} y={30}/>
            <Shimmer x={ACCOUNTS_GRID_WIDTH} y={45}/>
        </div>
    )
};